import type { Task, Timestamp } from "./types";

export const parseTimestamp = (timestamp: Timestamp | undefined) => {
  if (!timestamp || typeof timestamp.seconds === "undefined") return null;
  const milliseconds = Number(timestamp.seconds) * 1000;
  const nanosToMillis = (timestamp.nanos || 0) / 1000000;
  return new Date(milliseconds + nanosToMillis);
};

export function getLatestTask(taskName: string, tasks: Task[]): Task | null {
  const filteredTasks = tasks.filter((task) => task.name === taskName);
  if (filteredTasks.length === 0) return null;
  return [...filteredTasks].sort((a, b) => {
    const timeA = parseTimestamp(a.create_time);
    const timeB = parseTimestamp(b.create_time);
    if (!timeA && !timeB) return 0;
    if (!timeA) return 1;
    if (!timeB) return -1;
    return timeB.getTime() - timeA.getTime();
  })[0];
}
